import React from 'react';
import Link from 'next/link';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { CoworkerAvatar } from 'ui/components/CoworkerAvatar';
import TextAreaInputField from 'ui/components/forms/TextAreaInputField';
import InputField from 'ui/components/forms/InputField';
import asForm from 'ui/components/forms/asForm';
import LoadingSpinner from 'ui/components/LoadingSpinner';
import NxMentionsInput from 'ui/components/forms/NxMentionsInput/NxMentionsInput';

export const EventsPageCommentsFormField = asForm(
  withCustomComponent('EventsPageCommentsFormField')(
    inject(
      'appStore',
      'authStore',
      'eventsStore'
    )(
      withRouter(
        observer(
          ({
            newComment,
            updateProperty,
            authStore,
            router,
            appStore,
            eventsStore,
            componentName
          }) => {
            const { t } = useTranslation();
            const { isSavingNewComment } = eventsStore;
            const event = eventsStore.eventPage.Event;

            const saveNewMessage = () => {
              eventsStore
                .saveNewComment({ event_id: event.Id })
                .then(() => eventsStore.loadEventPage(event.Id))
                .catch((err) => {
                  appStore.setPopMessage(
                    t('Sorry, we could not post this comment. {{err}}', { err })
                  );
                });
            };

            return (
              <form data-component-name={componentName} noValidate className="d-flex mt-24">
                <div className="w-100">
                  <div>
                      <div className="row">
                        <div className="form-group col-12 ">
                          <InputField
                            id="newComment-title"
                            label={t('Subject')}
                            name="Title"
                            placeholder={t(
                              'Keep it relevant, less is more...'
                            )}
                            errors={
                              eventsStore.newCommentValidation.errors.Title
                            }
                            value={newComment.Title}
                            onChange={updateProperty}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-12 ">
                          <NxMentionsInput
                            label={t('Message')}
                            name="Comment"
                            placeholder={t(
                              t('Type your comment here...')
                            )}
                            errors={
                              eventsStore.newCommentValidation.errors
                                .Comment
                            }
                            value={newComment.Comment}
                            onChange={updateProperty}
                            onKeyDown={(ev) => {
                              if (
                                (ev.keyCode == 10 || ev.keyCode == 13) &&
                                (ev.ctrlKey || ev.metaKey)
                              ) {
                                if (isSavingNewComment) return;
                                ev.preventDefault();
                                saveNewMessage();
                              }
                            }}
                          />
                        </div>
                      </div>
                    <button
                      className="btn "
                      disabled={isSavingNewComment}
                      onClick={(ev) => {
                        if (isSavingNewComment) return;
                        ev.preventDefault();
                        saveNewMessage();
                        ev.target.blur();
                      }}
                    >
                      {isSavingNewComment ? (
                        <LoadingSpinner />
                      ) : (
                        t('Comment')
                      )}
                    </button>
                  </div>

                  <div className="text-gray-600 fs-12 lh-12 pt-4">
                    <small
                      className="d-block text-red"
                      data-bind="validationMessage: message"
                    ></small>
                    <p className="mb-0">
                      {t(
                        "Invite other people to this conversation by mentioning them: type the '@' symbol followed by their name."
                      )}
                    </p>
                  </div>
                </div>
              </form>
            );
          }
        )
      )
    )
  ),
  'newComment'
);
